export const POPUP_MESSAGES = {

    quotation__Request_Confirmation: {
        title: "Quotation Request Confirmation",
        message: "Would you like to confirm your request for a quotation?",
        btnTitle: "Confirm",
        salesMessage: "If you have any further questions or specific requirements, feel free to ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        linkMessage:'contact us'
    },

    quotation_Req_Successful: {
        title: "Thank you for your request!",
        message: "Our sales team will review your submission and prepare a quotation tailored to your needs. You can expect to hear back from us shortly.",
        salesMessage: "If you have any further questions or specific requirements, feel free to ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Okay",
        linkMessage:'contact us'
    },
    quotation_req_success_message: {
        title: "Quotation Confirmation Successful",
        message: "Your quotation confirmation was successful. Our Accounts team will review and then send you an email for quotation",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Okay",
        linkMessage:"NCache sales"
    },
    quotation_confirm_message:{
        title: "Quotation Confirmation",
        message: "Would you like to confirm your quotation?",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Confirm",
        linkMessage:'NCache Sales'
    },
    quotation_confirm_after_sales_approval:{
        title: "Finalize Your Purchase",
        message: "Please confirm that you would like to proceed with the purchase based on the quotation provided. By clicking 'Confirm', you acknowledge that the details of the quotation are accurate and agree to move forward with the order.",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Confirm",
        linkMessage:'NCache Sales'
    },
    twenty_four_seven_request:{
        title:"Confirm 24x7 Support",
        message:"Are you sure want to continue with 24x7 Support?",
        btnTitle:'Okay',
        salesMessage: "If you have any further questions or specific requirements, feel free to ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        linkMessage:'contact us'
    },
    twenty_four_seven_success_message: {
        title: "24x7 Request Successful",
        message: "Your request for 24x7 support was successfully submitted. Our Sales team will review and than send you an email for confirmation.",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Okay",
        linkMessage:'NCache Sales'
    },
    confirm_configure_environment:{
        title:"Confirm Environment Configuration",
        message:"You are about to configure the environment with the specified configuration. \n Please note that this process may take a few minutes to complete. Do you want to proceed with configuring this environment now?",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Confirm",
        linkMessage:'NCache Sales'
    },
    confirm_create_environment:{
        title:"Confirm Environment Creation",
        message:"You are about to create the environment with the specified configuration. \n Please note that this process may take a few minutes to complete. Do you want to proceed with creating this environment now?",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Confirm",
        linkMessage:'NCache Sales'
    },
    confirm_configure_environment_success:{
        title:"Environment Deployment in Progress",
        message:"Your deployment process is now underway. This may take a few minutes to complete. Once the deployment is completed, you will receive a notification. And the status will be updated on your dashboard.",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Okay",
        linkMessage:'NCache Sales'
    },
    confirm_create_environment_success:{
        title:"Environment Deployment in Progress",
        message:"Your deployment process is now underway. This may take a few minutes to complete. Once the deployment is completed, you will receive a notification. And the status will be updated on your dashboard.",
        salesMessage: "If you have any question, please contact ",
        salesLink: "https://www.alachisoft.com/company/contact-us.html",
        btnTitle: "Okay",
        linkMessage:'NCache Sales'
    },
};

export const VMStateLabels = {
    Starting: "starting",
    Running: "running",
    Stopping: "stopping",
    Stopped: "stopped",
    Deallocating: "deallocating",
    Deallocated: "deallocated",
    Unknown: "unknown",
} as const;

export const VALIDATION_ERRORS = {

    remove_env: {
        title: "delete-env",
        message: "At least one environment is required."
    },

    request_quotation: {
        title: "request-quotation",
        message: "One or more fields invalid. Please provide valid data."
    }

}

export const API_ERRORS = {

    otp_verification: {
        title: "otp-verification-err",
    },

    get_quotation_environments: {
        title: "get-quotation-environments",
        message: "There was an issue contacting the server. Please try again in a few minutes."
    },

    verify_quotation_otp: {
        title: "verify-quotation-otp-error",
    },

    resend_quotation_otp: {
        title: "resend-quotation-otp-failed",
        message: "You are not allowed to resend OTP again. Please wait for ${duration} seconds."
    },

    purchase_quotation: {
        title: "purchase-quotation",
        message: "Purchase Could not be made. Some error occured!"
    },

    getConfigureEnvironments: {
        title: "get-configure-environments"
    },

    get_environment_information: {
        title: "get-environment-information",
    },

    get_user_details: {
        title: "get-user-details",
        message: "Could not fetch user details"
    },

    get_subscription_list: {
        title: "get-subscription-list",
        message: "Could not fetch subscriptions list"
    },

    get_ncache_versions: {
        title: "get-ncache-versions",
        message: "Could not fetch ncache versions"
    },

    get_subscription_details: {
        title: "get-subscription-details",
        message: "Could not fetch subscription details"
    },

    get_environment_servers: {
        title: "get-environment-servers",
        message: "Could not fetch environment servers"
    },

    get_subscription_plan: {
        title: 'get-subscription-plan'
    },

    confirm_plan: {
        title: "confirm_plan",
    }

}

export const SUCCESS = {

    create_quotation: {
        title: "create-quotation",
        message: "Purchase Successful!"
    },

    plan_confirmed: {
        title: "plan_confirmed",
        message: "${plan} is confirmed and subscription is activated"
    }

}

export const PasswordFields = {
    Password: 'passwordShow',
    Confirm_Password: 'passwordConfirmShow'
} as const;

export const DefaultExpirationValues = {
    USER_INACTIVITY_EXPIRY_TIME_SEC: 14400
} as const;